import React from "react"

export const onClientEntry = () => {
  if (process.env.NODE_ENV !== "production") {
    const whyDidYouRender = require("@welldone-software/why-did-you-render")
    whyDidYouRender(React, {
      trackAllPureComponents: false,
    })
  }
}

// This is a trick to avoid updating the scroll on certain route changes
export const shouldUpdateScroll = ({ routerProps }) => {
  if (!routerProps.location.state) {
    return
  }
  const { disableScrollUpdate } = routerProps.location.state
  return !disableScrollUpdate
}
